export default "__VITE_ASSET__6f9e4a6f__"